/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Open_Panel_BtnInputs */

const tr_geliver_tracking_open_panel_btn = /** @type {(inputs: Geliver_Tracking_Open_Panel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kargo Takip`)
};

const en_geliver_tracking_open_panel_btn = /** @type {(inputs: Geliver_Tracking_Open_Panel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track Shipment`)
};

const de_geliver_tracking_open_panel_btn = /** @type {(inputs: Geliver_Tracking_Open_Panel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sendung verfolgen`)
};

const ru_geliver_tracking_open_panel_btn = /** @type {(inputs: Geliver_Tracking_Open_Panel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отследить`)
};

/**
* | output |
* | --- |
* | "Track Shipment" |
*
* @param {Geliver_Tracking_Open_Panel_BtnInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_open_panel_btn = /** @type {((inputs?: Geliver_Tracking_Open_Panel_BtnInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Open_Panel_BtnInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_open_panel_btn(inputs)
	if (locale === "de") return de_geliver_tracking_open_panel_btn(inputs)
	if (locale === "ru") return ru_geliver_tracking_open_panel_btn(inputs)
	return tr_geliver_tracking_open_panel_btn(inputs)
});